import * as types from './types';

const getFormValues = payload => {
  return {
    type: types.GET_FORM_VALUES,
    meta: {
      async: true,
      blocking: false,
      api: 'publicadorProf',
      path: `/publication/api/v1/posting/STEP_LOCATION/${payload.postingId}`,
      method: 'GET'
    }
  };
};

const getLatLngData = (lat = null, lng = null) => ({
  type: types.GET_COORDINATES,
  meta: {
    async: true,
    blocking: false,
    api: 'publicadorProf',
    path: `/publication/api/v1/location/geopoint?lat=${lat}&lng=${lng}`,
    coordinates: { lat, lng },
    method: 'GET'
  }
});

const getLocation = (location, zone) => {
  return {
    type: types.GET_LOCATION,
    meta: {
      async: true,
      blocking: false,
      api: 'publicadorProf',
      path: `/publication/api/v1/location/${location}/children`,
      method: 'GET',
      locationName: [zone]
    }
  };
};

const getCep = CEP => ({
  type: types.GET_CEP,
  meta: {
    async: true,
    blocking: false,
    api: 'publicadorProf',
    path: `/publication/api/v1/location/geopoint?cep=${CEP}`,
    method: 'GET'
  }
});

const setAddress = payload => ({
  type: types.SET_ADDRESS,
  payload
});

const setCep = payload => ({
  type: types.SET_CEP,
  payload
});

const setAddressComplement = payload => ({
  type: types.SET_ADDRESS_COMPLEMENT,
  payload
});

const setPostalCode = payload => ({
  type: types.SET_POSTALCODE,
  payload
});

const setSelectedProvince = (data, reset) => ({
  type: types.SET_SELECTED_PROVINCE,
  payload: {
    data,
    reset
  }
});

const setSelectedCity = (data, reset) => ({
  type: types.SET_SELECTED_CITY,
  payload: {
    data,
    reset
  }
});

const setSelectedDistrict = (data, reset) => ({
  type: types.SET_SELECTED_DISTRICT,
  payload: {
    data,
    reset
  }
});

const setSelectedSubDistrict = payload => ({
  type: types.SET_SELECTED_SUBDISTRICT,
  payload
});

const setVisibility = payload => ({
  type: types.SET_VISIBILITY,
  payload
});

const resetValues = () => ({
  type: types.RESET_VALUES
});

const resetCoordinates = () => ({
  type: types.RESET_COORDINATES
});

const resetCepError = () => ({
  type: types.RESET_CEP_ERROR
});

const setIsEdited = payload => ({
  type: types.SET_EDITED,
  payload
});

const saveStep1Module2 = payload => ({
  type: types.SAVE_STEP1_MODULE_2,
  payload
});

const resetInfo = () => ({
  type: types.RESET_INFO
});

const setEditValues = payload => ({
  type: types.SET_EDIT_VALUES,
  payload
});

const setCoordinates = payload => ({
  type: types.SET_COORDINATES,
  payload
});

export {
  getLatLngData,
  getLocation,
  setAddress,
  setSelectedProvince,
  setSelectedCity,
  setSelectedDistrict,
  setSelectedSubDistrict,
  setVisibility,
  resetValues,
  setIsEdited,
  saveStep1Module2,
  resetInfo,
  setEditValues,
  getFormValues,
  setCoordinates,
  getCep,
  setCep,
  setAddressComplement,
  setPostalCode,
  resetCepError,
  resetCoordinates
};
